export default {
  DETAILS: {
    bars: [
      {
        type: 'circle',
      },
    ],
  },
};

export const VIS_VARS = {
  S: 'Scale',
  L: 'Length',
  G: 'Angle',
  A: 'Area',
  V: 'Volume',
  C: 'Color',
  N: 'Connection',
  M: 'Multiplication',
  '+': 'More Interpretable',
  '-': 'Less Interpretable',
};

export const VALUE_TYPES = {
  RELATIVE_CONTINUOUS: 1,
  RELATIVE_DISCRETE: 2,
  PROPORTIONAL: 3,
  CONNECTION: 4,
};

export const COLORS = {
  GREEN: '#00e150',
  DARK_GREY: '#20232a', // '#333333',
  PINK: '#ff3a55',
};



// WEBPACK FOOTER //
// ./src/constants.js